import { API, IResponse, onDayDelay } from "./API";

export interface IAddClassRequest {
  _name: string;
  _gradeId: number;
  _teacherId: number;
}
export interface IUpdateClassRequest {
  _name: string;
  _teacherId: string;
  _id: string;
}
export interface IFetchClassesEntity {
  _color: string;
  _grade: string;
  _gradeAr: string;
  _gradeEn: string;
  _gradeId: number;
  _id: number;
  _name: string;
  _noOfStudents: number;
  _noOfTeachers: number;
  _school: string;
  _schoolId: number;
  _teacherId: number;
  _teacherName: string;
}

interface IFetchClassesResponse extends IResponse {
  _entity: IFetchClassesEntity[];
}

const classesServices = API.injectEndpoints({
  endpoints(build) {
    return {
      fetchClasses: build.query<IFetchClassesResponse, string>({
        query(schoolId) {
          return `hod/school/${schoolId}/class`;
        },
        providesTags: ["Classes"],
        keepUnusedDataFor: onDayDelay,
      }),
      addClass: build.mutation<IResponse, IAddClassRequest[]>({
        query(data) {
          return {
            url: `hod/class`,
            method: "POST",
            body: data,
          };
        },
        invalidatesTags: ["Classes", "Teachers"],
      }),
      updateClass: build.mutation<IResponse, IUpdateClassRequest>({
        query(data) {
          return {
            url: `hod/class`,
            method: "PUT",
            body: data,
          };
        },
        invalidatesTags: ["Classes", "Teachers"],
      }),
      deleteClass: build.mutation<IResponse, number>({
        query(classId) {
          return {
            url: `hod/class/${classId}`,
            method: "DELETE",
          };
        },
        invalidatesTags: ["Classes", "Teachers"],
      }),
    };
  },
});

export const {
  useFetchClassesQuery,
  useAddClassMutation,
  useDeleteClassMutation,
  useUpdateClassMutation,
} = classesServices;
